import { render, staticRenderFns } from "./SvgPreviewEditor.vue?vue&type=template&id=011616f8&scoped=true"
import script from "./SvgPreviewEditor.vue?vue&type=script&lang=js"
export * from "./SvgPreviewEditor.vue?vue&type=script&lang=js"
import style0 from "./SvgPreviewEditor.vue?vue&type=style&index=0&id=011616f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011616f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011616f8')) {
      api.createRecord('011616f8', component.options)
    } else {
      api.reload('011616f8', component.options)
    }
    module.hot.accept("./SvgPreviewEditor.vue?vue&type=template&id=011616f8&scoped=true", function () {
      api.rerender('011616f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SvgPreviewEditor.vue"
export default component.exports